const routePaths = {
  default: "/",
  sites: "/sites",
  selectedSite: "site/:id/*",
};

export default routePaths;
